import {pollProgressUntilDone} from "./aiApi";

export let detachResumeListener = null;

export const attachResumeListenerOnce = (dispatch, getState, signal) => {
  if (detachResumeListener) return;

  let resumeAbortController = null;
  let inFlight = false;

  const resumeIfNeeded = async () => {
    if (document.visibilityState !== "visible") return;
    if (signal?.aborted) return;

    const { aiWaitingId } = getState().aiState;
    if (!aiWaitingId || inFlight) return;

    resumeAbortController?.abort();
    resumeAbortController = new AbortController();

    inFlight = true;
    try {
      await pollProgressUntilDone({
        aiWaitingId,
        signal: resumeAbortController.signal,
        dispatch,
        getState,
      });
    } finally {
      inFlight = false;
    }
  };

  const onVisibility = () => {
    if (document.visibilityState === "visible") {
      resumeIfNeeded();
    } else {
      resumeAbortController?.abort();
    }
  };

  document.addEventListener("visibilitychange", onVisibility);
  window.addEventListener("focus", resumeIfNeeded);
  window.addEventListener("pageshow", resumeIfNeeded);

  detachResumeListener = () => {
    document.removeEventListener("visibilitychange", onVisibility);
    window.removeEventListener("focus", resumeIfNeeded);
    window.removeEventListener("pageshow", resumeIfNeeded);
    resumeAbortController?.abort();
    detachResumeListener = null;
  };
};
